import React, { useState } from "react";
import { Button, Icon } from "../../";
import BusinessSelectionModal from "../../POS/BusinessSelectionModal";
import { usePostHog, useIntercom } from "@finitless/shared/hooks";
import { useTranslation } from "react-i18next";

const SalesChannelCard = ({ integration }) => {
  const { t } = useTranslation("integrations");
  const { name, logo, plugin } = integration;
  const { isFeatureEnabled } = usePostHog();
  const { showMessenger } = useIntercom();
  const salesChannelsConfigureEnabled = isFeatureEnabled(
    "sales_channels_configure_enabled",
  );

  const [isBusinessModalOpen, setIsBusinessModalOpen] = useState(false);

  const handleConfigure = (e) => {
    e.stopPropagation();
    setIsBusinessModalOpen(true);
  };

  return (
    <div className="ordering-integration-card border-border bg-background flex h-full flex-col rounded-lg border p-6 transition-colors">
      {/* Header */}
      <div className="mb-4">
        <div className="mb-3 flex items-start justify-between">
          <div className="flex min-w-0 items-center gap-3">
            {logo ? (
              <div className="border-border bg-card flex h-12 w-12 flex-shrink-0 items-center justify-center overflow-hidden rounded-lg border">
                <img
                  src={logo}
                  alt={name}
                  className="h-full w-full object-cover"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
                <div className="bg-secondary text-foreground flex hidden h-full w-full items-center justify-center text-xs font-semibold">
                  {name.charAt(0)}
                </div>
              </div>
            ) : (
              <div className="border-border bg-card flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg border">
                <Icon
                  name="ShoppingCart"
                  className="text-muted-foreground h-6 w-6"
                />
              </div>
            )}
            <div className="min-w-0 flex-1">
              <h3 className="text-foreground mb-1 text-lg font-semibold break-words">
                {name}
              </h3>
              {/* Description */}
              <p className="text-muted-foreground text-sm">
                {plugin?.description || "Sales channel integration platform"}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="border-border mt-auto space-y-2 border-t pt-4">
        {salesChannelsConfigureEnabled ? (
          <Button
            type="button"
            onClick={handleConfigure}
            emphasis="solid"
            intent="brand"
            size="touch"
            className="w-full"
          >
            <span>Configure</span>
          </Button>
        ) : (
          <Button
            onClick={(e) => {
              e.stopPropagation();
              showMessenger();
            }}
            emphasis="solid"
            intent="neutral"
            size="touch"
            className="w-full"
          >
            <Icon name="MessageCircle" className="me-2 h-4 w-4" />
            <span>{t("contactUs")}</span>
          </Button>
        )}
      </div>

      {/* Business Selection Modal */}
      <BusinessSelectionModal
        isOpen={isBusinessModalOpen}
        onClose={() => setIsBusinessModalOpen(false)}
        integration={integration}
        integrationType="sales_channel"
      />
    </div>
  );
};

export default SalesChannelCard;
